var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "preferred-agents" } },
    [
      !_vm.modalEnabled
        ? _c(
            "div",
            { staticClass: "preferred-agents-container" },
            [
              _vm._l(_vm.getSelectedAgents(), function (agent) {
                return _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                        },
                        expression:
                          "{\n                followCursor: true,\n                placement: 'bottom-end',\n            }",
                      },
                    ],
                    key: agent._id,
                    staticClass: "preferred-agents-element",
                    style: {
                      borderColor: agent.color + " !important",
                    },
                    attrs: { content: agent.name },
                  },
                  [
                    _c("div", {
                      staticClass: "circle",
                      style: {
                        backgroundColor: _vm.isDarkMode ? "white" : "black",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            _vm.visibleModal = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              agent.name.slice(0, 15) +
                                (agent.name.length >= 15 ? "..." : "")
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              !_vm.readOnly
                ? _c(
                    "button",
                    {
                      staticClass: "add-dashed-btn",
                      on: {
                        click: function ($event) {
                          _vm.visibleModal = true
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalEnabled || _vm.visibleModal
        ? _c("FormModal", {
            attrs: {
              title: _vm.$t("message.assignPreferredAgent"),
              subtitle: _vm.$t("message.representativeAssignedToTheVisitor"),
            },
            on: {
              cancel: function () {
                return _vm.modalEnabled
                  ? _vm.$emit("cancel")
                  : (_vm.visibleModal = false)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "pf-main" }, [
                        _c("div", { staticClass: "pr-search" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchText,
                                expression: "searchText",
                              },
                            ],
                            attrs: {
                              placeholder: _vm.$t(
                                "message.searchRepresentative"
                              ),
                            },
                            domProps: { value: _vm.searchText },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.searchText = $event.target.value
                                },
                                _vm.searchChange,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "material-icons mx-2 pr-icon" },
                            [_vm._v(" search ")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pr-items pr-item-wrapper" },
                          _vm._l(_vm.filterUsers, function (agent) {
                            return _c(
                              "div",
                              {
                                staticClass: "pr-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleAgent(agent._id)
                                  },
                                },
                              },
                              [
                                _c("a-checkbox", {
                                  staticClass: "segment-checkbox",
                                  attrs: {
                                    checked: _vm.selectedAgentIds.includes(
                                      agent._id
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "user-data-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "user-data" },
                                      [
                                        _c("Avatar", {
                                          staticClass: "mr-2 avatar",
                                          attrs: {
                                            size: 30,
                                            src: agent.gravatar,
                                            username: agent.name,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "metas" }, [
                                          _c(
                                            "div",
                                            { staticClass: "pr-item-name" },
                                            [_vm._v(_vm._s(agent.name))]
                                          ),
                                          _vm._v(" "),
                                          _c("div", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.getUserDepartmentNames(
                                                    agent
                                                  )
                                                ) +
                                                "\n                                    "
                                            ),
                                          ]),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "pr-item-status",
                                        attrs: {
                                          "data-online":
                                            _vm.$_.get(_vm.user, "_id") ===
                                            agent._id
                                              ? true
                                              : agent.isOnline,
                                          "data-status":
                                            agent.status.toLowerCase(),
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "pr-item-status-circle",
                                        }),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(agent.status) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "footer",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        { staticClass: "actions" },
                        [
                          _c("a-button", { on: { click: _vm.handleCancel } }, [
                            _vm._v(" " + _vm._s(_vm.$t("message.cancel"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "pr-confirm-btn",
                              attrs: {
                                type: "primary",
                                disabled: !_vm.isChanged(),
                              },
                              on: { click: _vm.handleConfirm },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$t("message.save")) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              750246042
            ),
            model: {
              value: _vm.selectedAgentIds,
              callback: function ($$v) {
                _vm.selectedAgentIds = $$v
              },
              expression: "selectedAgentIds",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }